module.exports = __webpack_public_path__ + "static/media/bg-city.1112bfef.webp";